<div class="main-content-container">
  <div class="page-title-container d-flex">
    <div class="page-title flex-grow-1">
      <span>Landing Url</span>
    </div>
  </div>
  @if (currentFields.blocks) {
    <div class="main-container-body">
      <div class="main-box-shadow app-ui-engine-container">
        <dhs-form [action]="'MODIFY'" [fieldGroup]="currentFields" [config]="config" [decorator]="decorator"
          (saveFinished)="onSaveFinished($event)" (cancel)="cancelButtonClick()">
        </dhs-form>
      </div>
    </div>
  }
</div>